export const decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_components/:component/base_creatives";
